import * as React from 'react';
import { Link } from 'react-router-dom';

import { CountryCode, ProductItem } from './types';
import { getProductItemsExport } from '../api';
import { Spinner } from '../assets/Spinner';
import { Table } from '../component/Table';
import { TableTools } from '../component/TableTools';
import { useFetchWithPagination } from '../hooks/useFetchWithPagination';
import { ProductItemsHeader } from '../tableHeaders';

export const ProductItems = ({ country }: { country: CountryCode }) => {
  const basePath =
    country === CountryCode.US ? '/manage-data/product-items-us' : '/manage-data/product-items-ca';

  const mapItem = (productItem: ProductItem) => {
    return {
      'Product Code': (
        <Link
          to={`${basePath}/update-product-items/${productItem.id}`}
          className="text-blue-500 hover:underline"
        >
          {productItem.code}
        </Link>
      ),
      'Product Name': productItem.name,
      'Product Status': country === CountryCode.US ? productItem.status_us : productItem.status_ca,
      Items:
        productItem.items.length > 0
          ? productItem.items.map((item) => `${item.sku} x ${item.quantity}`)
          : 'N/A',
    };
  };

  const {
    currentData: data,
    renderPagination,
    reFetch,
    searchBy,
    isLoading,
    ...forPagination
  } = useFetchWithPagination<ProductItem>({
    endpoint: `/product_items/?country=${country}`,
    mapper: mapItem,
  });

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <div className="relative h-[calc(100vh-77px)] bg-slate50 p-8">
      <div className="flex items-center justify-between mb-3">
        <h1>
          {country === CountryCode.US ? '🇺🇸' : '🇨🇦'} {country} Product-Items
        </h1>
      </div>
      <TableTools
        renderPagination={renderPagination}
        forPagination={forPagination}
        isLoading={isLoading}
        searchBy={searchBy}
        searchPlaceholder="Search for a product"
        reFetch={reFetch}
        hasData={data.length > 0}
        createLabel="Create New Product-Item Mapping"
        createLink={`${basePath}/create-product-items`}
        changelogLink={`${basePath}/changelog`}
        onClickDownload={() => getProductItemsExport(country)}
      >
        <Table header={ProductItemsHeader} data={data} internalPagination={false} />
      </TableTools>
    </div>
  );
};
